/*
 * Copyright(c) 2021 architectural award, All Rights Reserved.
 * Author: lxj
 */
import fetch from '@/utils/fetch';

export default {
  listAd: params => {
    return fetch({
      url: 'ad/list',
      method: 'get',
      params
    })
  },
  getAd: params => {
    return fetch({
      url: 'ad/info',
      method: 'get',
      params
    })
  },
  searchAd: params => {
    return fetch({
      url: 'ad',
      method: 'get',
      params
    })
  },
  searchVideoAd: params => {
    return fetch({
      url: 'ad/video',
      method: 'get',
      params
    })
  },
  searchPictureAd: params => {
    return fetch({
      url: 'ad/picture',
      method: 'get',
      params
    })
  },
  createAd: data => {
    return fetch({
      url: 'ad',
      method: 'post',
      data
    })
  },
  updateAd: data => {
    return fetch({
      url: 'ad',
      method: 'put',
      data
    })
  },
  deleteAd: params => {
    return fetch({
      url: 'ad',
      method: 'delete',
      params
    })
  }
}